<div>
	<p-table class="config-infoset-table" [value]="entries" rowHover="false" [resizableColumns]="true"
		[scrollable]="true" scrollHeight="calc(75vh)" (sortFunction)="doCustomSort($event)" [customSort]="true">

		<ng-template pTemplate="header">
			<tr>
				<th pResizableColumn pSortableColumn="configKey">
					Config Key
					<p-sortIcon field="configKey"></p-sortIcon>
				</th>
				<th pResizableColumn pSortableColumn="initialCapture">
					Initial Capture
					<p-sortIcon field="initialCapture"></p-sortIcon>
				</th>
				<th pResizableColumn pSortableColumn="lastCapture">
					Last Capture
					<p-sortIcon field="lastCapture"></p-sortIcon>
				</th>
				<th></th>
			</tr>
		</ng-template>

		<ng-template pTemplate="body" let-rowData>
			<tr (click)="viewConfig($event, rowData)">
				<td>
					<span class="uv-table-value">{{ rowData.configKey }}</span>
				</td>
				<td>
					<span class="uv-table-value">{{ formatDateHm(rowData.initialCapture) }}</span>
				</td>
				<td>
					<span class="uv-table-value">{{ formatDateHm(rowData.lastCapture) }}</span>
				</td>
				<td [ngClass]="{'uv-table-button-column-2': !isAdminValid, 'uv-table-button-column-3': isAdminValid }">
					<button type="button" class="btn btn-primary uv-table-button" title="View this config"
						(click)="viewConfig($event, rowData)"><i class="fa fa-eye"></i></button>
					<button type="button" class="btn btn-primary uv-table-button"
						title="Compare this config with other configs" (click)="diffConfig($event, rowData)"><i
							class="fa fa-columns"></i></button>
					<button type="button" [disabled]="!isAdminValid" class="btn btn-danger uv-table-button"
						title="Delete this config capture" (click)="tryDeleteResult($event, rowData)"><i
							class="pi pi-trash"></i></button>
					<button type="button" [disabled]="!isAdminValid" class="btn btn-danger uv-table-button"
						title="Delete all config captures with this key" (click)="tryDeleteKeyResults($event, rowData)"><i
							class="pi pi-bolt"></i></button>
					<button type="button" [disabled]="!isAdminValid" class="btn btn-danger uv-table-button"
						title="Delete all config captures for this device" (click)="tryDeleteAllResult($event, rowData)"><i
							class="pi pi-asterisk"></i></button>
				</td>
			</tr>
		</ng-template>
	</p-table>

	<p-dialog [(visible)]="displayViewConfigDialog" class="view-config-dialog" [resizable]="true" [modal]="true"
		[style]="{'max-width': '100%'}" appendTo="body">

		<p-header>
			<span>Config: {{configKey}}</span>
		</p-header>

		<pre>{{configText}}</pre>

		<p-footer>
			<button type="button" pButton icon="fa fa-file-o" iconPos="left" (click)="exportConfig()"
				label="Export"></button>
			<button type="button" pButton icon="fa fa-times" (click)="closeViewConfigDialog()" label="Close"></button>
		</p-footer>

	</p-dialog>

	<diff-viewer [(visible)]="displayDiffConfigDialog" [deviceGuid]="deviceGuid" [deviceName]="deviceName"
		[infoSetView]="infoSetView" [configKey]="configKey" [configLastCapture]="configLastCapture"
		[configText]="configText" (onClose)="closeDiffConfigDialog()"></diff-viewer>

</div>

<confirmation-dialog message="Are you sure you want to delete the capture result(s)?"
	[display]="displayDeleteResultConfirm" (onYes)="deleteResult()" (onNo)="cancelDeleteResult()">
</confirmation-dialog>